import { jsx as _jsx } from "react/jsx-runtime";
import { useFormState, useWatch } from 'react-hook-form';
import { useState } from 'react';
import { useSession } from '../../../../infra/session';
import { canUserViewAppointmentContactInfo } from '../../../../../app/common/helpers/users';
import { SelectClientView } from './select-client';
import { usePhoneInput } from './use-phone-input';
import { useEmailInput } from './use-email-input';
export var SelectClientContainer = function (_a) {
    var form = _a.form;
    var _b = useState(''), searchBy = _b[0], setSearchBy = _b[1];
    var formState = useFormState({
        name: ['customerId', 'name', 'phone', 'email', 'notes', 'appointmentNotes'],
        control: form.control,
    });
    var customerId = useWatch({
        name: 'customerId',
        control: form.control,
    });
    var onClientInfoUpdated = function (fieldName, value) {
        form.setValue(fieldName, value);
        setSearchBy(value);
    };
    var session = useSession().data;
    var maskContactInfo = !canUserViewAppointmentContactInfo(session.view.permissions);
    var phoneInput = usePhoneInput({
        maskContactInfo: maskContactInfo,
        onClientInfoUpdated: onClientInfoUpdated,
        form: form,
    });
    var emailInput = useEmailInput({
        maskContactInfo: maskContactInfo,
        onClientInfoUpdated: onClientInfoUpdated,
        form: form,
    });
    var onClientSelected = function (selectedResult) {
        form.setValue('customerId', selectedResult.id);
        form.setValue('name', selectedResult.name);
        form.setValue('notes', selectedResult.notes);
        phoneInput.setPhoneFromSelectedClient(selectedResult.phone);
        emailInput.setEmailFromSelectedClient(selectedResult.email);
    };
    var onRemoveSelectedClient = function () {
        form.setValue('customerId', '');
        form.setValue('name', '');
        phoneInput.setPhoneFromSelectedClient('');
        emailInput.setEmailFromSelectedClient('');
        form.setValue('notes', '');
        setSearchBy('');
    };
    var errors = formState.errors;
    var isExistingClientSelected = !!customerId;
    var showSearchResults = !isExistingClientSelected && searchBy.length > 0;
    return (_jsx(SelectClientView, { showRemoveClientButton: isExistingClientSelected, onRemoveClientClicked: onRemoveSelectedClient, isNameDisabled: isExistingClientSelected, isClientNotesDisabled: isExistingClientSelected, form: form, onClientInfoUpdated: onClientInfoUpdated, phoneInput: phoneInput, emailInput: emailInput, errors: errors, showClientSearchResults: showSearchResults, maskContactInfo: maskContactInfo, searchBy: searchBy, onClientSelected: onClientSelected }));
};
